export default __webpack_public_path__ + "static/media/Planet2.5facfc4c.png";